export default __webpack_public_path__ + "static/media/success.308cba67.svg";